import React from 'react';
import CityLandingPage from '../CityLandingPage/CityLandingPage';
import { cityContent } from '../../data/cityLandingContent';

const LandingPageBurgos = props => {
  return <CityLandingPage cityKey="Burgos" cityConfig={cityContent.burgos} {...props} />;
};

export default LandingPageBurgos;
